module.exports = __webpack_public_path__ + "static/img/b2.4324e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b2.png
// module id = 5ZwE
// module chunks = 1